import {
    SET_NOTA_BIMESTRE_TIPO
} from './actionTypes'

export function setNotaBimestreTipo(notaBimestreTipo){
    return {type : SET_NOTA_BIMESTRE_TIPO, notaBimestreTipo}
}